import React, { useState, useLayoutEffect } from "react"
import { useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"

import { userLogout } from "utils"
import { Button, Modal } from "components"
import classes from "./SystemIsNotActivatedModal.module.scss"

const SystemIsNotActivatedModal = () => {
  const [t] = useTranslation()

  const history = useHistory()

  const [openSystemIsNotActivatedModal, setOpenSystemIsNotActivatedModal] = useState(false)

  const systemIsActivated =
    useSelector(state =>
      state.systemSettings.systemIsActivated
    )

  const handleLogout = () => {
    userLogout()

    history.push("/")
  }

  useLayoutEffect(() => {
    setOpenSystemIsNotActivatedModal(
      !systemIsActivated
    )
  }, [systemIsActivated])

  return (
    <Modal
      className={classes["modal"]}
      show={openSystemIsNotActivatedModal}
    >
      <div className={classes["container"]}>
        <div className={classes["title"]}>
          {t("سیستم هنوز فعال نشده")}
        </div>
        <div className={classes["text"]}>
          {t("لطفا_از_ادمین_بخواهید_که_سیستم_شما_را_فعال_کند")}
        </div>
        <div className={classes["text"]}>
          {t("تماس_با_پشتیبانی")}: <a className={classes["tel"]} href="tel:+982191094093">02191094093</a>
        </div>
        <div className={classes["footer"]}>
          <Button onClick={handleLogout}>
            {t("خروج")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default React.memo(SystemIsNotActivatedModal)